import { useState } from 'react';

function KeywordSearch(props) {
  const [params, setParams] = useState('');

  // console.log('keyword is: ', params);
  return (
    <div className="nl_flex position-relative mb-5">
      <div className="col pr-0 position-relative n_input_box">
        <input
          className="nl_input"
          onChange={e => setParams(e.target.value)}
          name="keyword"
          placeholder="검색어를 입력하세요"
        />
        <span
          className="nl_search d-block mt-1"
          onClick={() => props.onSearchHandler(params)}
        ></span>
      </div>
    </div>
  );
}

export default KeywordSearch;
